import { Component } from '@angular/core';

@Component({
  selector: 'app-truck-icon',
  imports: [],
  templateUrl: './truck-icon.html',
  styleUrl: './truck-icon.scss'
})
export class TruckIcon {

}
